import React, { useContext } from 'react';
import { elementNames } from 'src/Booking/components/CreateUsernameForm/constants';
import { CreateUsernameFormContext } from 'src/Booking/components/CreateUsernameForm/CreateUsernameFormProvider';
import { CreatePasswordFormContext } from './CreatePasswordFormProvider';
import CreatePasswordFormView from './CreatePasswordFormView';

const CreatePasswordFormContainer = (props) => {
    const formContext = useContext(CreatePasswordFormContext);
    const usernameContext = useContext(CreateUsernameFormContext);
    return (
        <CreatePasswordFormView
            email={usernameContext.values[elementNames.email]}
            {...props}
            {...formContext}
        />
    );
};

export default CreatePasswordFormContainer;
